module.exports = __webpack_public_path__ + "img/Chart.842c3f6b.svg";